import { FC } from 'react';

import Heading from '@/components/common/Heading';

interface IServicesBlockItemProps {
  title: string;
  text: string;
}

const ServicesBlockItem: FC<IServicesBlockItemProps> = ({ title, text }) => {
  return (
    <>
      <div className=" flex flex-col h-full border px-6 py-10 bg-[--bg-block-color] rounded-xl shadow-[0_5px_10px_rgba(0,0,0,.12)]">
        <div className="flex gap-2 items-center mb-4 ">
          <Heading headingLevel="h4" className="">
            {title}
          </Heading>
        </div>
        <p className="custom-p">{text}</p>
      </div>
    </>
  );
};

export default ServicesBlockItem;
